import axios from "axios";
import { Auth } from "aws-amplify";

export const addAudience = async (data) => {
  let obj = {
    emailAddress: data.email
  };
  let url = `${process.env.REACT_APP_MAILCHIMP_API}/addToBetaUserList`;
  fetch(url, {
    method: "post",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "x-api-key": process.env.REACT_APP_API_KEY
    }
  })
    .then(function (response) {
      return response.json();
    })
    .then(async (data) => {
      localStorage.setItem("mailId", data.id);
    })
    .catch((err) => {
      console.log("error-mailchimp", err);
      // Alert(400, err.message);
    });
};

export const updateTagToHasPlayed = async (data) => {
  let obj = {
    subscriber_hash: data.subscriber_hash,
    tag: data.tag
  };
  let url = `${process.env.REACT_APP_MAILCHIMP_API}/updateUserTag`;
  fetch(url, {
    method: "post",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "x-api-key": process.env.REACT_APP_API_KEY
    }
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      localStorage.removeItem("mailId");
      // Alert(200, data.message);
    })
    .catch((err) => {
      console.log("error-mailchimp", err);
      // Alert(400, err.message);
    });
};

export async function updateUserAttributes(attribute, callback) {
  try {
    const user = await Auth.currentAuthenticatedUser({
      bypassCache: true
    });
    let result = await Auth.updateUserAttributes(user, attribute);
    callback(result);
  } catch (err) {
    console.log("error setting user attributes: ", err);
    callback(err);
  }
}

export async function deleteUserAttributes(attribute, callback) {
  try {
    const user = await Auth.currentAuthenticatedUser({
      bypassCache: true
    });
    let result = await Auth.deleteUserAttributes(user, attribute);
    callback(result);
  } catch (err) {
    console.log("error deleting user attributes: ", err);
    callback(err);
  }
}

export async function updateCognitoAttribute(data) {
  let url = process.env.REACT_APP_UPDATECOGNITOATTRIBUTES;

  axios
    .post(url, {
      ...data
    })
    .then(function (response) {
      console.log(response, "response=>>");
    })
    .catch(function (error) {
      console.log(error);
    });
}
